/** @format */

import { ProductSku } from './product-sku.interface';
import { ProductStyle } from './product-style.interface';
import { QueryParam } from './query-param.interface';

export interface ProcessedNonBundleProduct extends ProductStyle {
  actualAdditionalQueryParams?: QueryParam[];
  colorQueryParam?: string;
  customSeoUrl?: string;
  defaultColor?: string;
  isBundle?: false;
  skuIdList?: string[];
  skuIdQueryParam?: string;
  skus?: ProductSku[];
}
